import { Button, Popover, Segmented, Tooltip } from "antd";
import InlineEditTitle from "components/inline-edit-title";
import { CiqIconBox, CopyIcon } from "components/svg-icons";
import { useEffect, useState } from "react";
import "./bid-package-header.scss";
import ErrorBoundary from "components/error-boundary";
import { useHistory, useLocation, useParams } from "react-router";
import { ArrowLeftOutlined } from "@ant-design/icons";
import DemoTextIcon from "components/svg-icons/demo-icon";

function FeatureHeader(props: {
  title: string;
  subTitle?: string;
  actions?: any;
  headerTitle?: string;
  number?: string;
  status?: any;
  disabled?: boolean;
  feature: "BID_PACKAGE" | "DESIGN_PACKAGE";
  goBackToList: () => void;
}) {
  const {
    actions,
    title,
    subTitle,
    headerTitle,
    number,
    status,
    disabled,
    feature,
    goBackToList
  } = props;
  const { projectId, designPackageId } = useParams() as any;
  const location = useLocation();
  const history = useHistory();
  const tab = new URLSearchParams(location.search).get("tab");
  const [tabIndex, setTabIndex] = useState<string>(tab || "1");

  const [visible, setVisible] = useState(false);
  const [headerInfo, setHeaderInfo] = useState<{
    featureHeaderNumber?: string;
    featureHeaderTitle?: string;
  }>();

  const updateHeaderInfo = async (headersInfo: any) => {
    setHeaderInfo({
      featureHeaderNumber: headersInfo?.number,
      featureHeaderTitle: headersInfo?.title
    });
    await actions.updateFeatureInstanceFields({
      title: headersInfo?.title,
      number: headersInfo?.number
    });
  };

  useEffect(() => {
    setHeaderInfo({
      featureHeaderNumber: number,
      featureHeaderTitle: headerTitle
    });
  }, [headerTitle, number]);

  const segmentOptions = [{ label: "Details", value: "1" }];

  return (
    <div className="flex flex-col w-full bg-white px-6 py-4 space-y-2">
      <div className="flex justify-between items-center">
        <div className="flex space-x-2 items-center">
          <Button
            icon={<ArrowLeftOutlined />}
            className="text-one text-black !bg-transparent !border-0 px-0 !shadow-none"
            onClick={goBackToList}
            data-testid="index-button-back-to-list"
          />
          <CiqIconBox feature={feature} size={20} padding={8} />
          <div className="flex-col pl-1">
            <div className="flex items-center space-x-2">
              <div className="text-xl font-semibold">{title}</div>
              <DemoTextIcon />
            </div>
            {subTitle && <div className="text-xs font-normal">{subTitle}</div>}
          </div>
          {segmentOptions.length > 1 && (
            <Segmented
              shape="round"
              size="large"
              value={tabIndex}
              options={segmentOptions}
              onChange={(value) => {
                console.log(value); // string
                setTabIndex(value as string);

                history.push(
                  `/project/${projectId}/design-packages/${designPackageId}?tab=${value}`
                );
              }}
            />
          )}
        </div>

        <div className="flex space-x-2">
          <Popover
            open={visible}
            placement="bottomRight"
            // content={<div>Test</div>}
            trigger="click"
            onOpenChange={() => {
              setVisible(!visible);
            }}
            destroyTooltipOnHide
          >
            <Tooltip>
              <Button
                onClick={() => setVisible(true)}
                data-testid="index-button-duplicate"
                disabled
              >
                <div className="flex items-center space-x-2">
                  <div className=" text-[12px]">Duplicate</div>
                  <CopyIcon />
                </div>
              </Button>
            </Tooltip>
          </Popover>
        </div>
      </div>

      <div className="flex py-2 md:px-16 lg:px-24 sm:px-4 items-center justify-center">
        <div className="flex w-full p-4 bg-ciq-gray-400 bg-opacity-60 items-center justify-between">
          <ErrorBoundary>
            <InlineEditTitle
              isPermissionToEdit={!disabled}
              headerInfo={headerInfo}
              updateHeaderInfo={updateHeaderInfo}
              feature={feature}
            />
          </ErrorBoundary>
          <div className="flex items-center">{status}</div>
        </div>
      </div>
    </div>
  );
}

export default FeatureHeader;
